// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__2aKvT","TM":"Hero_TM__xFcSr"};